export default function BlogHero() {
  return (
    <section className="relative py-24 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: 'url(https://public.readdy.ai/ai/img_res/4edc6e89b85bf80c19147978f645f1e6.jpg)' }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-green-900/85 via-green-800/65 to-green-700/40"></div>
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <span className="inline-flex items-center bg-amber-500/90 text-white text-xs font-semibold px-4 py-1.5 rounded-full uppercase tracking-widest mb-5">
          <i className="ri-leaf-line mr-2"></i>Health Tips · Farming Insights · Recipes
        </span>
        <h1 className="text-4xl md:text-6xl font-bold text-white mb-5 leading-tight">
          The MY AVA Farms Blog
        </h1>
        <p className="text-xl text-green-100 max-w-2xl mx-auto">
          Practical health tips, moringa recipes, BSF farming insights, and stories from our farm in Accra, Ghana.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-3 mt-8">
          {['Moringa Health', 'Recipes', 'BSF Farming', 'Sustainability'].map((tag) => (
            <span key={tag} className="bg-white/15 backdrop-blur-sm text-white text-sm font-medium px-4 py-1.5 rounded-full border border-white/20">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
